import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const eventMappings = {};
eventMappings[actions.VOTE_REGISTRATION_COMPLETED] = [trackCompleteAction];
eventMappings[actions.VOTE_REGISTRATION_CANCELED] = [trackCancelAction];

export default function trackVoteRegistration(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: state.voteRegistration.actionCompletionTime
    });
}

function trackCancelAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCancelTime: state.voteRegistration.actionCancelledTime
    });

    apiTracking.trackCancelAction(state, state.voteRegistration.actionCancelledTime);
}



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/tracking.js